import { type ComponentPropsWithoutRef, forwardRef } from "react"
import { cn } from "../../utils/cn"

type DSRadioProps = Omit<ComponentPropsWithoutRef<"input">, "type"> & {
  invalid?: boolean
}

const DSRadio = forwardRef<HTMLInputElement, DSRadioProps>(function DSRadio(
  { checked, className, defaultChecked, invalid = false, ...props },
  ref
) {
  return (
    <span className="relative inline-flex size-5 shrink-0 items-center justify-center">
      <input
        checked={checked}
        className={cn(
          "peer m-0 size-5 cursor-pointer appearance-none rounded-full border bg-body-light-mode-1 transition-[background-color,border-color,opacity] duration-150 ease-out checked:border-brand-primary-3 disabled:cursor-not-allowed disabled:border-gray-3 disabled:bg-gray-2",
          invalid ? "border-feedback-danger" : "border-gray-5",
          className
        )}
        defaultChecked={defaultChecked}
        ref={ref}
        type="radio"
        {...props}
      />
      <span
        aria-hidden
        className="pointer-events-none absolute size-3 rounded-full bg-brand-primary-3 opacity-0 transition-opacity duration-150 ease-out peer-checked:opacity-100 peer-disabled:bg-gray-4"
      />
    </span>
  )
})

DSRadio.displayName = "DSRadio"

export type { DSRadioProps }
export { DSRadio }
